import { render } from "./NewViewInvoice.vue?vue&type=template&id=2bdbb743&scoped=true"
import script from "./NewViewInvoice.vue?vue&type=script&lang=js"
export * from "./NewViewInvoice.vue?vue&type=script&lang=js"

import "./NewViewInvoice.vue?vue&type=style&index=0&id=2bdbb743&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdbb743"]])

export default __exports__